import {useContext} from 'react';
import {SidePanelContext} from '@contexts';

export const useSidePanel = () => {
  return useContext(SidePanelContext);
};
